(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.userEndpoint = userEndpoint;
  _exports.userEntityKey = void 0;
  _exports.usersEndpoint = usersEndpoint;

  /**
   * Entity key used by the user schema
   * @type {string}
   */
  var userEntityKey = "users";

  /**
   * Endpoint to access or manipulate the user, for a given event
   * @param   {number|string} userId - Id of the user
   * @param   {number|string} eventId - Id of the event
   * @returns {Function} Function taking the API root URL as argument and
   * returning the endpoint
   */
  _exports.userEntityKey = userEntityKey;
  function userEndpoint(userId, eventId) {
    // Event id is passed to get the stats from this event only
    return function (apiUrl) {
      return "".concat(apiUrl, "users/").concat(userId, "/?event=").concat(eventId);
    };
  }

  /**
   * Endpoint to access or manipulate users, for a given event
   * @param   {number|string} eventId - Id of the event
   * @returns {Function} Function taking the API root URL as argument and
   * returning the endpoint
   */
  function usersEndpoint(eventId) {
    return function (apiUrl) {
      return "".concat(apiUrl, "events/").concat(eventId, "/users/");
    };
  }
});